"use client";

import DashboardSidebar from "@/components/dashboard/sidebar";

const LeftSidebar = () => {
  // const pathname = usePathname();
  // const isAdminRoute = pathname.includes("/admin");

  // return isAdminRoute ? (
  //   <AdminSidebar className="relative z-20 hidden md:block" />
  // ) : (
  //   <DashboardSidebar className="relative z-20 hidden md:block" />
  // );
  return <DashboardSidebar className="relative z-20 hidden md:block" />;
};

export default LeftSidebar;
